import React, { Component } from 'react'

// flag
import getFlag from './flags/getFlag'

// pop over
import Popover from '../../../components/uielements/popover'

// style
import TopbarDropdownWrapper from './topbarDropDown.style'
import IntlMessages from '../../../components/utility/intlMessages'

// redux
import { connect } from 'react-redux'
import languageActions from '../../../redux/language/actions'

class SelectLanguage extends Component {
    constructor(props) {
        super(props)
        this.handleVisibleChange = this.handleVisibleChange.bind(this)
        this.hide = this.hide.bind(this)
        this.state = {
            visible: false,
        }
    }
    hide() {
        this.setState({ visible: false })
    }
    handleVisibleChange() {
        this.setState({ visible: !this.state.visible })
    }

    render() {
        const { listLangs, currentLang, changeLanguage} = this.props

        const content = (
            <TopbarDropdownWrapper className="isoUserDropdown">
                
                {
                    listLangs.map((lang, index) => {
                        return (
                            <a className="isoDropdownLink" onClick={() => changeLanguage(lang.code)} key={index}>
                                <div>
                                    <img src={getFlag(lang.code)} style={{height: 13, width: 21, marginRight: 10}}/>
                                </div>
                                <IntlMessages id={lang.id } />
                            </a>
                        )
                    })
                }
            </TopbarDropdownWrapper>
        )

        return (
            <Popover
                content={content}
                trigger="click"
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}
                arrowPointAtCenter={true}
                placement="bottomLeft"
                style={{width: "100%"}}
            >
                <div style={{width: "100%"}}>
                    <IntlMessages id={"topbar.language.title" } />
                </div>
            </Popover>
        )
    }
}

const mapStateToProps = state => {
    return {
        listLangs: state.language.listLangs,
        currentLang: state.language.lang
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changeLanguage: lang => {
            dispatch(languageActions.action.changeLanguage(lang));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectLanguage)